import { IApplicationState } from '../types/redux';

export function favoriteSelector(state: IApplicationState) {
  return state.newbuilding.isFavorite;
}
